import {
  AccordionProps,
  AccordionSummaryProps,
  ListItemTextProps,
  ListSubheaderProps,
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  ListItemText as MuiListItemText,
  ListSubheader as MuiListSubheader,
  styled,
} from "@mui/material";

import { TaskStatus } from "@/features/assessments/features/utils";
import { DeclinedIcon, FinishedIcon, InProgressIcon, NotStartedIcon } from "@/ui-components/Icons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  borderBottom: "1px solid var(--green-grey-scale-100)",
  "&:before": {
    display: "none",
  },
}));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {},
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    marginTop: "16px",
    marginBottom: "16px",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "var(--green-grey-scale-700)",
  },
  "& .MuiTypography-root": {
    color: "var(--grey-scale-900)",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  padding: 0,
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const ListItemText = styled(MuiListItemText)<ListItemTextProps>(() => ({
  ".MuiTypography-root": {
    color: "var(--grey-scale-900)",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
  },
}));

export const StatusBox = styled("div")(() => ({
  paddingLeft: "16px",
  marginRight: "8px",
}));

export const StatusIcon: React.FC<{ status: number }> = ({ status }) => {
  if (status === TaskStatus.UNASSIGNED) {
    return <NotStartedIcon />;
  }
  if (status === TaskStatus.PENDING_DATA) {
    return <InProgressIcon />;
  }
  if (status === TaskStatus.DECLINED) {
    return <DeclinedIcon />;
  }

  return <FinishedIcon />;
};

export const ListSubheader = styled(MuiListSubheader)<ListSubheaderProps>(() => ({
  color: "var(--grey-scale-700)",
  fontSize: "12px",
  fontWeight: "700",
  lineHeight: "18px",
  textTransform: "uppercase",
  paddingLeft: "32px",
}));
